// Code common to all site pages lives here

/* global jQuery */

const $             	= jQuery;   // jQuery loaded via WordPress enqueue process
// const dc            = require('./utilities/device-check');
const header        	= require('./components/header');
// const lity          = require('lity');
// const anims			= require('./components/anims');
const expandCollapse	= require('./components/expand-collapse');

function initHeader() {
	// console.log("COMMON: initHeader()");
    let $header = $('.site-header');
    if ($header.length) {
        header.init($header);
    }
}

function initHeroVideo() {
	// If Hero has video, note via class whether it is loaded in a mobile or desktop viewport width.
	// console.log("COMMON: initHeroVideo()");
	let $heroVidContainer = $('.hero-block__video-container');
	if ($heroVidContainer.length > 0) {
		// console.log("COMMON: initHeroVideo(): ACTIVE: "+$('.hero-block__video-container'));
		if ($(window).width() >= 1024) {
			$heroVidContainer.addClass('opened-in-desktop');
		} else {
			$heroVidContainer.addClass('opened-in-mobile');
		}
	}
}

function initTopButton() {
	let $topButton = $('.top-button');

    var offset = 200;
    var speed = 250;
    var duration = 250;

	$(window).scroll(function(){
		if ($(this).scrollTop() < offset) {
			$topButton.fadeOut(duration);
		} else {
			$topButton.fadeIn(duration);
		}
	});
	$topButton.on('click', function() {
		$('html, body').animate({scrollTop:0}, speed);
		return false;
	});	
}

exports.init = function() {
    // Do common initialization...
	initHeader();
	initHeroVideo();
	initModule(expandCollapse);
	// initTopButton();	// COMMENTING OUT 240311. Waiting for request/feedback.
};

function initModule(mod) {
	console.log("COMMON: initModule(): "+mod);
    if ((mod !== null) && (typeof mod !== 'undefined') && (typeof mod.init === 'function')) {
        mod.init();
    }
}